import { render, staticRenderFns } from "./NonSerializedTab.vue?vue&type=template&id=84c3b91c"
import script from "./NonSerializedTab.vue?vue&type=script&lang=js"
export * from "./NonSerializedTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports